module.exports = __webpack_public_path__ + "img/electric_icon.1944cd68.svg";